type AgencyLogoFields = {
  logo_url?: string | null
  logo_url_light?: string | null
}

/**
 * Picks the agency logo for the active theme.
 * - Dark (black) theme → logo_url
 * - Light (white) theme → logo_url_light, falling back to logo_url
 */
export function getAgencyLogoUrl(
  agency: AgencyLogoFields | null | undefined,
  isDark: boolean,
  fallback = ''
): string {
  if (!agency) return fallback

  if (isDark) {
    return agency.logo_url || fallback
  }

  return agency.logo_url_light || agency.logo_url || fallback
}
